<template>
  <vs-popup class="create-new-crm-subejct" id="popup" :title="isCreateMode ? 'ADD VAM TYPE' : 'UPDATE VAM TYPE'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-crm-subejct-popup" @submit.prevent="handleSubmit(onClickSubmitForm)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name" name="name" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="resetForm" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CrmRepository = RepositoryFactory.get('crm');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      name: '',
      order: 1
    },
    isCreateMode: true
  }
}

export default {
  name: 'AddNewCrmVamTypePopUp',
  data() {
    return initialState()
  },
  methods: {
    resetForm() {
      const currentOrder = this.form.order;
      this.form = {
        name: '',
        order: currentOrder
      };
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    },
    async openPopup(id = null, nextOrder = 1) {
      try {
        Object.assign(this.$data, initialState());
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
        this.open = true;
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchCrmSubjectDetails()
        } else {
          this.isCreateMode = true
          this.form.order = nextOrder || 1
        }
      } catch (error) {

      }
    },
    async fetchCrmSubjectDetails() {
      await this.$vs.loading({
        container: '#create-crm-subejct-popup',
        scale: 0.45
      })
      try {
        const { data } = (await CrmRepository.getCrmVamType(this.id)).data
        this.form = {
          ...data,
          order: data.order !== null && data.order !== undefined ? data.order : 1
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-crm-subejct-popup > .con-vs-loading')
    },
    async onClickSubmitForm() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-crm-subejct-popup',
        scale: 0.45
      })
      try {
        const payload = {
          ...this.form,
          order: this.form.order !== null && this.form.order !== undefined && this.form.order !== '' ? Number(this.form.order) : 1
        }
        if (this.isCreateMode) {
          await CrmRepository.createCrmVamType(payload);
          this.showSuccessMessage('vam type added!');
        } else {
          await CrmRepository.updateCrmVamType(this.id, payload);
          this.showSuccessMessage('VAM type updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-crm-subejct-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-crm-subejct-popup > .con-vs-loading')
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.create-new-crm-subejct>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}
</style>
